import { api } from "api";
import { useQuery } from "@tanstack/react-query";

export function useStripeAccountStatus() {
    return useQuery({
        queryKey: ["stripeAccountStatus"],
        queryFn: async (context) => await api.provider.stripeAccountStatus(context.signal),
        refetchOnWindowFocus: true,
    });
}
